import { isNil } from '#layers/base/public';

/**
 * Joins the parts of a composite cache key, or returns `undefined` when any part is missing.
 *
 * A template literal would stringify a missing part to `"undefined"`, which is a valid-looking key:
 * the row caches under `<id>__undefined` beside the complete row and both match a relation joining
 * on only one part, and rstore's `isKeyDefined` guards never fire. Returning `undefined` makes
 * rstore reject the write instead, which is loud but correct.
 */
export function compositeKey(...parts: Array<string | number | null | undefined>): string | undefined {
	if (parts.some((part) => isNil(part))) return undefined;

	return parts.join('__');
}
